export default [
    {
        path: '/supervision/geolocation',
        name: 'geolocation',
        meta: {
            layout: 'session'
        },
        component: () => import('VIEWS/supervision/Geolocation.vue')
    }
]